import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getWorksMaterialProductionRateNorms: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].GET_WORKS_MATERIAL_PRODUCTION_RATE_NORMS,
	},
	getBaseWorksMaterialProductionRateNorms: {
		useCache: true,
		cacheStorage: STORE_MAP.BASE,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].GET_WORKS_MATERIAL_PRODUCTION_RATE_NORMS,
	},
	getExtendedWorksMaterialProductionRateNorms: {
		useCache: true,
		cacheStorage: STORE_MAP.EXTENDED,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].GET_WORKS_MATERIAL_PRODUCTION_RATE_NORMS,
	},
	createWorksMaterialProductionRateNorm: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].CREATE_WORKS_MATERIAL_PRODUCTION_RATE_NORM,
	},
	getWorksMaterialProductionRateNorm: {
		useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].GET_WORKS_MATERIAL_PRODUCTION_RATE_NORM,
	},
	patchWorksMaterialProductionRateNorm: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].PATCH_WORKS_MATERIAL_PRODUCTION_RATE_NORM,
	},
	putWorksMaterialProductionRateNorm: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].PUT_WORKS_MATERIAL_PRODUCTION_RATE_NORM,
	},
	deleteWorksMaterialProductionRateNorm: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].DELETE_WORKS_MATERIAL_PRODUCTION_RATE_NORM,
	},
}